import { useCallback, useState } from "react";
import { Button, Icon } from "@simplybusiness/mobius";
import { cross } from "@simplybusiness/icons";
import { StickyFooter, StickyFooterText } from "../shared/StickyFooter";

interface LiveChatInterventionProps {
  onClose?: () => void;
}

export const LiveChatIntervention = ({
  onClose,
}: LiveChatInterventionProps) => {
  const [isHidden, setIsHidden] = useState(false);

  const onCloseClick = useCallback(() => {
    setIsHidden(true);
    onClose?.();
  }, [onClose]);

  return (
    <StickyFooter className="live-chat" hidden={isHidden}>
      <StickyFooterText
        headlineText="Have questions about your quotes? Live chat with a consultant to understand your options."
        descriptionText=""
      />
      <Button
        className="live-chat-intervention__button"
        variant="secondary"
        size="sm"
        data-testid="live-chat-intervention-button"
      >
        Open live chat
      </Button>
      <button
        type="button"
        className="live-chat__close-button"
        onClick={onCloseClick}
        aria-label="Close"
        title="Close"
        data-testid="live-chat-close-button"
      >
        <Icon icon={cross} size="md" title="Close" />
      </button>
    </StickyFooter>
  );
};
